import React, { useCallback } from "react";
import { SectionHeading, Reveal, CropFrame } from "./ui";

const missions = [
  {
    title: "Engineering excellence",
    body: "We deliver end-to-end semiconductor and embedded engineering services—from architecture and design to advanced verification and physical design. With deep domain expertise, we help reduce risk across the design and verification cycle and build robust embedded solutions for diverse applications.",
  },
  {
    title: "Talent solutions",
    body: "We bridge critical workforce gaps by connecting businesses with highly skilled semiconductor professionals. Our curated talent pool of IC designers, FPGA specialists, verification experts, and firmware developers helps accelerate project timelines and drive innovation.",
  },
  {
    title: "Strategic partnership",
    body: "We combine the strength of offshore expertise with U.S.-based program management to provide cost-effective, scalable, and secure solutions. Our flexible engagement models enable rapid team scaling, ensuring seamless collaboration, IP protection, and sustained innovation.",
  },
];

export default function CompanyDetails() {
  // React's `muted` prop only sets the DOM property, not the HTML attribute, so
  // pre-rendered HTML ships without it and browsers block autoplay. Set both.
  const setVideoRef = useCallback((node) => {
    if (node) {
      node.muted = true;
      node.setAttribute("muted", "");
      node.play?.().catch(() => {});
    }
  }, []);

  return (
    <section className="section relative overflow-hidden bg-white">
      <div className="bg-grid-light absolute inset-0 [mask-image:linear-gradient(to_bottom,black,transparent_60%)]" aria-hidden="true" />
      <div className="container-x relative grid gap-16 lg:grid-cols-12 lg:gap-20">
        <div className="lg:col-span-5 lg:sticky lg:top-28 lg:self-start">
          <SectionHeading index="01" eyebrow="Who we are" title="Built by engineers, for engineering teams." className="mb-12" />
          <CropFrame label="Fig. 01 — Silicon bring-up" className="max-w-sm">
            <div className="overflow-hidden rounded-sm bg-navy-900">
              <video
                ref={setVideoRef}
                src="/semiconvideo.mp4"
                autoPlay
                loop
                muted
                playsInline
                preload="metadata"
                aria-hidden="true"
                className="aspect-[4/5] w-full object-cover"
              />
            </div>
          </CropFrame>
        </div>

        <div className="lg:col-span-7 lg:pt-4">
          {missions.map((m, i) => (
            <Reveal key={m.title} delay={i * 80}>
              <article className="grid gap-6 border-t border-slate-200 py-10 first:border-t-0 first:pt-0 md:grid-cols-[5rem_1fr] md:gap-10 md:py-14">
                <span className="font-display text-5xl font-semibold tracking-tighter text-slate-200 md:text-6xl">
                  0{i + 1}
                </span>
                <div>
                  <h3 className="text-2xl font-semibold tracking-tight text-ink md:text-3xl">{m.title}</h3>
                  <p className="mt-4 text-lg leading-relaxed text-slate-600">{m.body}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
